import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import detector from "i18next-browser-languagedetector";
import pl from "./translations/pl.json";
import en from "./translations/pl.json";
import sk from "./translations/pl.json";

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    debug: true,
    fallbackLng: "pl",
    defaultNS: "common",
    resources: {
      pl: { common: pl },
      en: { common: en },
      sk: { common: sk },
    },
  });

export default i18n;
